export class Environment {

    public static isLocal() {
        return false;
    }

    public static isInternal() {
        return false;
    }

    public static isLive() {
        return !this.isLocal() && !this.isInternal();
    }

    public static isBPS() {
        return /packageName=org\.pbskids\.gamesapp/.test(window.location.search);
    }
}
